import { lazy, Suspense } from 'react';
import { Hero } from '../components/home/Hero';
import { About } from '../components/home/About';
import { PRE_LAUNCH_MODE } from '../config/maintenance';

const Gallery = lazy(() => import('../components/home/Gallery').then(m => ({ default: m.Gallery })));
const Stats = lazy(() => import('../components/home/Stats').then(m => ({ default: m.Stats })));
const Activities = lazy(() => import('../components/home/Activities').then(m => ({ default: m.Activities })));
const SeasonSection = lazy(() => import('../components/home/SeasonSection').then(m => ({ default: m.SeasonSection })));
const Amenities = lazy(() => import('../components/home/Amenities').then(m => ({ default: m.Amenities })));
const Testimonials = lazy(() => import('../components/home/Testimonials').then(m => ({ default: m.Testimonials })));
const Location = lazy(() => import('../components/home/Location').then(m => ({ default: m.Location })));
const HouseRules = lazy(() => import('../components/home/HouseRules').then(m => ({ default: m.HouseRules })));
const Faq = lazy(() => import('../components/home/Faq').then(m => ({ default: m.Faq })));
const Host = lazy(() => import('../components/home/Host').then(m => ({ default: m.Host })));
const Booking = lazy(() => import('../components/home/Booking').then(m => ({ default: m.Booking })));
const GiftVoucher = lazy(() => import('../components/home/GiftVoucher').then(m => ({ default: m.GiftVoucher })));
const Contact = lazy(() => import('../components/home/Contact').then(m => ({ default: m.Contact })));

const SectionFallback = () => <div className="min-h-[40vh]" />;

const Lazy = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<SectionFallback />}>{children}</Suspense>
);

// A title/meta kezelését a Layout-ban ülő <SEO /> (useSeoMeta hook) végzi,
// nyelvváltáskor is — itt nem duplikáljuk.
export const Home = () => {
  return (
    <div>
      <Hero />
      {/* Pre-launch módban a többi szekció a DOM-ban marad (Google indexelési cél),
          de display:none-nel vizuálisan rejtve van. aria-hidden a screen readereknek. */}
      <div className={PRE_LAUNCH_MODE ? 'hidden' : 'contents'} aria-hidden={PRE_LAUNCH_MODE}>
        <About />
        <Lazy><Stats /></Lazy>
        <Lazy><Gallery /></Lazy>
        <Lazy><Activities /></Lazy>
        <Lazy><SeasonSection /></Lazy>
        <Lazy><Amenities /></Lazy>
        <Lazy><Testimonials /></Lazy>
        <Lazy><Location /></Lazy>
        <Lazy><HouseRules /></Lazy>
        <Lazy><Faq /></Lazy>
        <Lazy><Host /></Lazy>
        <Lazy><Booking /></Lazy>
        <Lazy><GiftVoucher /></Lazy>
        <Lazy><Contact /></Lazy>
      </div>
    </div>
  );
};
